<div [ngClass]="{
    'tech-icon-disabled': disabled,
    'tech-icon-darker': darken,
    'tech-icon-small': size === 'small',
    'tech-icon-medium': size === 'medium',
    'tech-icon-big': size === 'big'
}" [ngStyle]="{'background-color': defaultBackgroundColor}">
  <mat-icon [svgIcon]="technologyToIcon[technology]"
            [matTooltip]="tooltip || technologyToTooltip[technology]"
            [ngStyle]="{'color': defaultIconColor || technologyToColor[technology]}"
            [ngClass]="{
                'tech-icon-leading': leading,
                'tech-icon-disabled': disabled,
                'tech-icon-darker': darken,
                'tech-icon-small': size === 'small',
                'tech-icon-medium': size === 'medium',
                'tech-icon-big': size === 'big'
            }"
  ></mat-icon>
</div>
